import React, { useState } from 'react'
import CopyCourseMaterial from './CopyCourseMaterial'
import { FaCopy } from 'react-icons/fa'
import { Toaster } from 'react-hot-toast'

const PublishModal = (props) => {
  // 
  const [forSelfStudyingPurposes, setForSelfStudyingPurposes] = useState(true);
  return (
    <div className="px-4 py-8 flex flex-col">
      {/* <div className="flex items-center gap-2"></div> */}
      <div className="form-check form-switch  "
        style={{
          width: "fit-content",
        }}
      >
        <input className="form-check-input" type="checkbox" id="flexSwitchCheckDefault"
          checked={forSelfStudyingPurposes}
          onChange={e => {
            const value = e?.target?.checked ?? false;
            setForSelfStudyingPurposes(value);
          }}
        />
        <label className="form-check-label" for="flexSwitchCheckDefault">Is it for self learning purposes?</label>
      </div>
      <div className="flex items-center gap-2">
        <Toaster />
        <input id="publish_link" disabled readOnly type="text" className="input-bar" value={`${window.location.origin}/lessonsview${forSelfStudyingPurposes ? "sl" : ""}/${props.targetId}`} />
        <button
          onClick={props.callback_onclick}
          className="copy-link md:w-1/4"
        >
          <FaCopy fontSize={18} />
          <span className="max-md:hidden">Copy Link</span>
        </button>
      </div>

      <CopyCourseMaterial openModal={true} title={props.title} setOpenModal={props.closeModal} lesson_id={props.targetId} forSelfStudyingPurposes={forSelfStudyingPurposes} />
      <div className="mb-5"></div>
    </div>
  )
}

export default PublishModal